import { render, staticRenderFns } from "./contactService.vue?vue&type=template&id=a01544c4&scoped=true&"
import script from "./contactService.vue?vue&type=script&lang=js&"
export * from "./contactService.vue?vue&type=script&lang=js&"
import style0 from "./contactService.vue?vue&type=style&index=0&id=a01544c4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01544c4",
  null
  
)

export default component.exports